import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import * as merge from 'deepmerge';

// Use this method to transform keys that return from API("item.item" => item:{item:})
class CustomTranslateService implements TranslateLoader {
    constructor(private http: HttpClient, private translateResources: { prefix: string, suffix: string }[]) { }
    
    getTranslation(lang: string): Observable<any> {
        const requests = this.translateResources.map(resource => {
            const path = resource.prefix + lang + resource.suffix;
            return this.http.get(path).pipe(
                map((res => {
                    if (path.endsWith('.json')) return res;
                    let result = {};

                    Object.keys(res)
                        .filter(key => res[key] ? true : false)
                        .forEach(key => {
                            if (key.indexOf('.') === -1) { // Sections keys can contain multi level (ex:item.sub)
                                result[key] = res[key];
                                Object.keys(res[key]).filter(x => x.indexOf('.') >= 0)
                                    .forEach(k => {
                                        this.pushSplitKeys(result[key], k, res[key][k]);
                                        delete result[key][k];
                                    });
                            } else { // Hint key can contain multi level (ex: menu.item)
                                this.pushSplitKeys(result, key, res[key]);
                            }
                        });

                    return result;
                })),
                catchError(res => {
                    console.error('Could not find translation file:', path);
                    return of({});
                }));
        });
        return forkJoin(requests).pipe(map(response => merge.all(response)));
    }

    pushSplitKeys(result: object, key: string, val: any) {
        let parts = key.split('.');
        let last = parts[parts.length - 1];

        if (!result[parts[0]]) result[parts[0]] = {};
        let currentNode = result[parts[0]];
        parts.slice(1, -1).forEach(k => {
            currentNode[k] = {};
            currentNode = currentNode[k];
        });
        currentNode[last] = val;
    }
}

export function CustomLoaderFactory(http: HttpClient, translateResources: { prefix: string, suffix: string }[]) {
    return new CustomTranslateService(http, translateResources);
}